import Personal1 from "../../assets/personalwebv1.png";
import Personal2 from "../../assets/personalwebv2.png";
import SinangPermata from "../../assets/sinangpermatagroup.png";
import GeosatOffice from "../../assets/geosatoffice.png";
import Design1 from "../../assets/design.png";
import Work4 from "../../assets/weatherApp.png";

export const projectsData = [
  {
    id: 1,
    image: SinangPermata,
    title: "Sinang Permata Group",
    category: "web",
    link: "https://azmrfii.000webhostapp.com/",
  },
  {
    id: 2,
    image: GeosatOffice,
    title: "Geosat Office",
    category: "web",
    link: "#",
  },
  {
    id: 3,
    image: Personal1,
    title: "Personal Website-V1",
    category: "web",
    link: "https://azmrfii.netlify.app/",
  },
  {
    id: 4,
    image: Personal2,
    title: "Personal Website-V2",
    category: "web",
    link: "https://azzamrafizafran.vercel.app/",
  },
  {
    id: 5,
    image: Design1,
    title: "Brand design",
    category: "design",
    link: "#",
  },
  {
    id: 6,
    image: Work4,
    title: "Weather App",
    category: "app",
    link: "#",
  },
];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'web',
    },
    {
        name: 'app',
    },
    {
        name: 'design',
    },
]